module.exports = __webpack_public_path__ + "static/img/007.027a64df.jpg";